/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import { Button, Card, Form, InputNumber, Row, Col, Modal } from "antd";
import PageToolbar from "../../components/PageToolbar";
import GenericFromToDatePicker from "../../components/GenericFromToDatePicker";
import moment from "moment";
import GenericSelector from "../../components/GenericSelector";
import ReportFavoriteSave from "../../components/ReportFavoriteSave";
import { User, Job, OutputType, ProcessType } from "../../JmReact";
import ServiceCallsTable from "./ServiceCallsTable";
import GenericModal from "../../components/GenericModal";

class TeamScreen extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _fromDate: moment().subtract(1, 'week').format("YYYY-MM-DD"),
            _toDate: moment().format("YYYY-MM-DD"),
            _subjectList: "",
            _subjectDetailList: "",
            _statusList: "",
            _userTagList: "",
            _refreshRate: 10,
            _maxHoursView: 1,

            modalServiceCall: false,
            startRefreshTime: null,
            lastRefreshTime: null,
        };

        this.id = "SERVICE_CALLS";
        this.status_id = "SERVICE_CALL_STATUSES";

        this.api = {
            get: "get_service_calls"
        }

        this.selectors = [
            { id: "SERVICE_SUBJECTS_LIST", api: "service_subjects_list" },
            { id: "SERVICE_SUBJECT_DETAILS_LIST", api: "service_subject_details_list" },
            { id: "SELECTOR_TAG_TYPE_9", api: "get_tags_from_type_9" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        if (props.data[this.status_id] === undefined) props.data[this.status_id] = { ...props.data.genericData };
        this.selectors.forEach(x => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } });

        this.refreshTimer = null;
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.props.dataActions.genericDataGetRequested(
            this.status_id, this.props.user.companyCode, this.props.user.token, "get_service_call_statuses");
        this.sendAPI("get_filter_favorite_data", "_url\r" + window.location.pathname, (ob) => {
            if (ob.data) {
                let params = {}
                ob.data.split('\r').forEach(x => {
                    let y = x.split('\f');
                    params = { ...params, [y[0]]: y[1] === 'null' || y[1] === 'undefined' ? null : y[1] }
                })
                this.setState(params)
            }
        })
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22881);
    }

    sendAPI = (script, data, sCall) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType["OUTPUT_TYPE_DATA"], ProcessType["PROCESS_TYPE_SYNC"]);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCall, e => { console.error(e) });
    }

    filterSelector = (field, index, moreAttr) => {
        let props = { ...this.props }
        if (index > -1) props = { ...props, ...this.selectors[index] }
        if (moreAttr) props = { ...props, ...moreAttr }
        return ((<GenericSelector {...props} multi
            value={this.state[field] ? this.state[field].split(",") : []}
            onChange={e => { this.setState({ [field]: e?.join(",") }) }} />
        ))
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
        this.onRefreshTimer()
    }

    onRefreshTimer = () => {
        if (moment().diff(this.state.startRefreshTime, 'hours') >= this.state._maxHoursView) {
            this.setState({ modalServiceCall: false })
            return;
        }
        this.setState({ lastRefreshTime: moment().format("HH:mm:ss") }, () => {
            if (this.state._refreshRate > 0) {
                clearTimeout(this.refreshTimer)
                this.refreshTimer = setTimeout(() => {
                    this.refreshData()
                }, this.state._refreshRate * 60 * 1000)
            }
        })
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };
        const mobile = window.innerWidth > 600 ? false : true;

        return (<div style={divStyle}>
            <Card title={(<PageToolbar title={this.getText(22881)} showsearch={false} actionButtons={[]} />)}
                bordered={true} style={{ width: mobile ? '95%' : 1000 }}
                bodyStyle={{ padding: 16 }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                actions={[
                    <Button type="primary" onClick={() => {
                        this.setState({ modalServiceCall: true, startRefreshTime: moment() }, this.onRefreshTimer)
                    }}>{gt(22882)}</Button>,
                    <ReportFavoriteSave
                        {...this.props}
                        btnText={this.getText(22883)}
                        isNotReport
                        params={this.state}
                        datesToFavorites={[
                            { label: this.getText(22885), field: '_fromDate' },
                            { label: this.getText(22886), field: '_toDate' },
                        ]}
                    />,
                ]}>
                <Row>
                    <Col span={mobile ? 24 : 12} style={{ padding: 8 }}>
                        <Form.Item label={this.getText(22884)}>
                            <GenericFromToDatePicker
                                format={"DD/MM/YYYY"} inline
                                fromDate={{ label: this.getText(22885), value: this.state._fromDate, onChange: e => { this.setState({ _fromDate: e }) } }}
                                toDate={{ label: this.getText(22886), value: this.state._toDate, onChange: e => { this.setState({ _toDate: e }) } }}
                            />
                        </Form.Item>
                        <Form.Item label={this.getText(22887)}>
                            {this.filterSelector('_subjectList', 0)}
                        </Form.Item>
                        <Form.Item label={this.getText(22888)}>
                            {this.filterSelector('_subjectDetailList', 1)}
                        </Form.Item>

                    </Col>
                    <Col span={mobile ? 24 : 12}>
                        <Form.Item label={this.getText(22889)}>
                            {this.filterSelector('_statusList', -1, {
                                dataset: this.props.data[this.status_id].data.map(x => x.split("\f")).map(y => { return { code: y[0], name: y[1], color: y[3] } }),
                                backgroundSet: true
                            })}
                        </Form.Item>
                        <Form.Item label={this.getText(22890)}>
                            {this.filterSelector('_userTagList', 2)}
                        </Form.Item>
                        <Form.Item label={this.getText(22891)}>
                            <InputNumber min={1} max={999} precision={0} value={this.state._refreshRate} onChange={e => { this.setState({ _refreshRate: e }) }} />
                        </Form.Item>
                        <Form.Item label={this.getText(22892)}>
                            <InputNumber min={1} max={10} precision={0} value={this.state._maxHoursView} onChange={e => { this.setState({ _maxHoursView: e }) }} />
                        </Form.Item>

                    </Col>
                </Row>


            </Card>

            <GenericModal
                visible={this.state.modalServiceCall}
                onCancel={() => { this.setState({ modalServiceCall: false }) }}
                title={this.getText(22881)}
                actionButtons={[{
                    buttonType: 'refresh',
                    buttonFunction: this.refreshData
                }]}
                genericActionButtons={[
                    <span style={{ color: 'white' }}>{this.getText(22957)}: {this.state.lastRefreshTime}</span>
                ]}
            >
                <ServiceCallsTable {...this.props}
                    filters={{
                        _fromDateOpen: this.state._fromDate,
                        _toDateOpen: this.state._toDate,
                        _subjectList: this.state._subjectList,
                        _subjectDetailList: this.state._subjectDetailList,
                        _statusList: this.state._statusList,
                        _tagList: this.state._userTagList,
                    }} />
            </GenericModal>
        </div>)
    }

}

export default TeamScreen;